<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import moment from "moment";
import { Dropdown } from "bootstrap";
import ReportsHeader from "@/components/reports-header";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ReportsHeader,
  },
  data() {
    return {
      currenTotal: 0,
      day: moment(new Date(Date.now())).format("YYYY-MM-DD"),
      payid: [],
      final_total: [],
      billing_invoices: [],
      customerData: [],
      page: 1,
      total: 0,
      status: 1,
      limit: 50,
      pay_amount: 0,
      total_amount: 0,
      tot_pages: 0,
      BillingInvoicesSearchMode: false,
      resultStatus: null,
      searchModel: "",
      billing_invoices_id: [],
      x: [],
      customerInfo: [],
      search: "",
      selectedCustomers: null,
      bill: [],
      allSelected: false,
      searchInput: null,
      customer_id: null,
      branch_id: null,
      customer_bill_id: null,
      dropdown: null,
      filter: "all",
      filter_title: { name_en: "All", name: "الكل" },
      filter_pay: "",
      filterdPeriod: "During of ",
      date: {
        to: "",
      },
      tariffs: [],
      existingSalaryMonthes: [],
      // appprices:[]
    };
  },
  computed: {
    filteredCountries() {
      return this.customerInfo
        .filter((customerInfo) => {
          console.log(this.customerInfo);
          if (customerInfo.name.includes(this.search)) {
            console.log("mohamed test");
            console.log(customerInfo.name);
            return customerInfo.name;
          } else if (customerInfo.account_no == this.search) {
            return customerInfo.name;
          } else if (customerInfo.meter_no == this.search) {
            return customerInfo.name;
          }
        })
        .map((customerInfo) => {
          return (
            customerInfo.id +
            "-" +
            "(" +
            customerInfo.meter_no +
            ")" +
            "-" +
            customerInfo.name
          );
        });
    },
    generate() {
      return this.final_total
        .map((c) => {
          console.log("total", c.customer.tariff.fees);
          return c.customer.tariff.fees;
        })
        .reduce((a, b) => {
          this.total = parseInt(a) + parseInt(b);
          return this.total;
        }, 0);
    },
    pages() {
      const range = [];
      const start = Math.max(2, this.page - 2);
      const end = Math.min(this.tot_pages - 1, this.page + 2);

      for (let i = start; i <= end; i++) {
        range.push(i);
      }

      return range;
    },
  },
  methods: {
    getExistingMonth() {
      this.http.get("billing-invoices/exitsingMonthes").then((res) => {
        if (res.status) {
          this.existingSalaryMonthes = res.data.map((m) => ({
            label: m,
            value: m,
          }));
        }
      });
    },
    monthlyBilling() {
      console.log("fyou");

      var data = {
        title: "popups.generate_monthly_invoices",
        inputs: [
          {
            model: "month",
            type: "select",
            options: this.existingSalaryMonthes,
            label: "emps.payment_details.month",
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: async (obj) => {
              obj.branch_id = this.branch_id;
              this.$loading.show();
              if (obj.month)
                await this.http
                  .post("monthly-billing", {
                    month: obj.month.split("-")[1],
                    year: obj.month.split("-")[0],
                  })
                  .then(() => {
                    this.$loading.hide();
                    this.searchBillingInvoices(1);
                  });
              else
                this.popup.alert({
                  title: this.$t("popups.usersErrorTitle"),
                  msg: this.$t("popups.please_select_month"),
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    get(page) {
      if (this.date.to && this.date.from) {
        this.filterdPeriod = `
        ${moment(this.date.from).endOf("month").format("YYYY-MM-DD")}  - 
        ${moment(this.date.to).endOf("month").format("YYYY-MM-DD")}  `;
      } else if (this.date.to)
        this.filterdPeriod = `${moment(this.date.to)
          .endOf("month")
          .format("YYYY-MM-DD")}`;
      else if (this.date.from)
        this.filterdPeriod = `${moment(this.date.from)
          .endOf("month")
          .format("YYYY-MM-DD")}`;
      else this.filterdPeriod = "";

      console.log(page);

      this.http
        .post("billing-invoices/pagination", {
          limit: this.limit,
          page: page,
          filter: this.filter,
          date: {
            to: this.date.to
              ? moment(this.date.to)
                  .add(-1, "months")
                  .endOf("month")
                  .format("YYYY-MM-DD")
                  .toString()
              : "",
            from: this.date.from
              ? moment(this.date.from)
                  .add(-1, "months")
                  .endOf("month")
                  .format("YYYY-MM-DD")
                  .toString()
              : "",
          },
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.billing_invoices = res.data;
          this.getExistingMonth();
        });
    },
    searchBillingInvoices(page) {
      // if (!this.search.length) return this.get(page);

      if (this.date.to && this.date.from) {
        this.filterdPeriod = `
        ${moment(this.date.from).endOf("month").format("YYYY-MM-DD")}  - 
        ${moment(this.date.to).endOf("month").format("YYYY-MM-DD")}  `;
      } else if (this.date.to)
        this.filterdPeriod = `${moment(this.date.to)
          .endOf("month")
          .format("YYYY-MM-DD")}`;
      else if (this.date.from)
        this.filterdPeriod = `${moment(this.date.from)
          .endOf("month")
          .format("YYYY-MM-DD")}`;
      else this.filterdPeriod = "";

      console.log("ffffffffff", page, this.filter, this.pay, this.date);
      this.http
        .post("billing-invoices/search-invoices", {
          limit: this.limit,
          page: page,
          filter: this.filter,
          pay: this.filter_pay,
          search: this.search,
          date: {
            to: this.date.to
              ? moment(this.date.to)
                  .add(-1, "months")
                  .endOf("month")
                  .format("YYYY-MM-DD")
                  .toString()
              : "",
            from: this.date.from
              ? moment(this.date.from)
                  .add(-1, "months")
                  .endOf("month")
                  .format("YYYY-MM-DD")
                  .toString()
              : "",
          },
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.billing_invoices = res.data;
          this.getExistingMonth();
          console.log("searchBillingInvoices", this.billing_invoices);
        });
    },
    getTariffs() {
      this.http.get("tariff").then((res) => {
        if (res.status) this.tariffs = res.data;
      });
    },

    reset() {
      this.date = {};
      this.filterdPeriod = "";
      this.selectedPaymentStatus = null;
      this.selectedPayMethod = null;
      this.filter = "all";
      this.filter_pay = "";
      this.filter_title = { name_en: "All", name: "الكل" };
      this.searchBillingInvoices(1);
    },
    goToPage(p) {
      if (p < 1 || p > this.tot_pages) return;
      this.searchBillingInvoices(p);
    },
  },

  created() {
    const current_user = JSON.parse(localStorage.currentUser);
    this.branch_id = current_user.branch_id;
    console.log("bid", this.branch_id);

    // this.get(1);
    this.searchBillingInvoices(1);
    this.getTariffs();
    this.getExistingMonth();
    // this.selectedCustomer()
    //  this.getBillingInvoices()
  },
  mounted() {
    this.dropdown = new Dropdown(".dropdown-toggle.filter-assets");
  },
};
</script>

<template>
  <Layout>
    <div id="invoices-report" class="container-fluid">
      <div class="row no-print">
        <div class="col-6">
          <PageHeader
            :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            :title="$t('menu.menuitems.billing.subItems.billing_invoices')"
          />
        </div>
        <div class="col-6">
          <button
            type="button"
            name=""
            id=""
            class="btn btn-primary float-end"
            @click="monthlyBilling()"
          >
            {{ $t("customers.monthlyBilling") }}
          </button>
        </div>
      </div>
      <div class="row align-items-center no-print">
        <!-- search bar -->
        <div class="col-8 col-md-9 d-flex align-items-center gap-4">
          <div class="search-box chat-search-box">
            <div class="position-relative">
              <input
                @input="searchBillingInvoices(page)"
                type="text"
                class="form-control fa-lg text-light"
                :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
                :placeholder="$t('popups.search')"
                v-model="search"
                style="
                  background-color: #2a3042 !important;
                  width: 150px !important;
                "
              />
              <i class="bx bx-search-alt search-icon text-light"></i>
            </div>
          </div>
          <div class="mb-4">
            <label class="inline" for="toJobTitle">{{
              $t("report.from")
            }}</label>
            <input
              v-model="date.from"
              type="month"
              class="form-control fromto"
              id="toJobTitle"
            />
          </div>
          <div class="mb-4">
            <label class="inline" for="toJobTitle">{{ $t("report.to") }}</label>
            <input
              :disabled="!date.from"
              v-model="date.to"
              type="month"
              class="form-control fromto"
              id="toJobTitle"
            />
          </div>
          <div class="d-flex gap-2">
            <button
              type="button"
              name=""
              id=""
              @click="searchBillingInvoices(1)"
              class="btn btn-success"
            >
              {{ $t("popups.search") }}
            </button>
            <button
              type="button"
              name=""
              id=""
              @click="reset()"
              class="btn btn-primary"
            >
              {{ $t("popups.reset") }}
            </button>
          </div>
        </div>
        <!-- Filter by payment and Print oud -->
        <div class="col-4 col-md-3 mb-3 d-flex justify-content-around mt-3">
          <div class="float-end">
            <button
              type="button"
              name=""
              id=""
              @click="
                this.$store.dispatch('utils/printElement', {
                  elementId: 'invoices-report',
                  orientation: 'p',
                })
              "
              class="btn btn-success"
              :title="$t('popups.print')"
            >
              <i class="fas fa-print" aria-hidden="true"></i>
            </button>
          </div>
          <div class="">
            <div>
              <div class="position-relative">
                <input
                  type="text"
                  :value="
                    this.$i18n.locale == 'en'
                      ? filter_title.name_en
                      : filter_title.name
                  "
                  class="form-control"
                  readonly
                />
              </div>
            </div>
          </div>
          <div class="float-end">
            <div class="dropdown">
              <button
                class="btn btn-light dropdown-toggle filter-assets"
                @click="dropdown.toggle"
                data-bs-toggle="dropdown"
              >
                <span class="fa fa-filter"></span>
              </button>
              <ul
                class="dropdown-menu p-3"
                style="min-width: 250px; z-index: 100"
              >
                <!-- All -->

                <!-- Payment Status -->
                <li class="mb-3">
                  <label class="form-label fw-bold">{{
                    $t("popups.payment_status")
                  }}</label>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="paid"
                      name="payment_status"
                      v-model="selectedPaymentStatus"
                      :value="'paid'"
                      @change="
                        filter = 'paid';
                        filter_title = { name_en: 'Paid', name: 'مدفوع' };
                        searchBillingInvoices(1);
                      "
                    />
                    <label class="form-check-label" for="paid">{{
                      $t("popups.paid")
                    }}</label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="unpaid"
                      name="payment_status"
                      v-model="selectedPaymentStatus"
                      :value="'unpaid'"
                      @change="
                        filter = 'unpaid';
                        filter_title = { name_en: 'Unpaid', name: 'غير مدفوع' };
                        searchBillingInvoices(1);
                      "
                    />
                    <label class="form-check-label" for="unpaid">{{
                      $t("popups.unPaid")
                    }}</label>
                  </div>
                </li>

                <!-- Payment Method -->
                <li>
                  <label
                    class="form-label fw-bold"
                    :class="{ 'text-light': selectedPaymentStatus !== 'paid' }"
                    >{{ $t("popups.pay_method") }}</label
                  >
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="electricity"
                      name="pay_method"
                      v-model="selectedPayMethod"
                      :value="'recons'"
                      :disabled="selectedPaymentStatus !== 'paid'"
                      @change="
                        filter_pay = 'recons';
                        filter_title = {
                          name_en: 'NEC',
                          name: 'شركة الكهرباء',
                        };
                        searchBillingInvoices(1);
                      "
                    />
                    <label class="form-check-label" for="electricity">{{
                      $t("popups.nce")
                    }}</label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="self"
                      name="pay_method"
                      v-model="selectedPayMethod"
                      :value="'self'"
                      :disabled="selectedPaymentStatus !== 'paid'"
                      @change="
                        filter_pay = 'self';
                        filter_title = { name_en: 'customer', name: 'العميل' };
                        searchBillingInvoices(1);
                      "
                    />
                    <label class="form-check-label" for="self">{{
                      $t("popups.customer")
                    }}</label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="row my-4 print">
        <ReportsHeader
          :reportName="$t('reports.billing_invoices')"
          :filterdPeriod="
            filterdPeriod && $i18n.locale == 'ar'
              ? 'خلال  ' + filterdPeriod
              : filterdPeriod
              ? 'During of ' + filterdPeriod
              : ''
          "
        />
      </div>
      <!-- start customer table -->

      <table
        :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
        class="table table-centered table-nowrap table-striped table-hover align-middle"
      >
        <thead>
          <tr class="text-light" style="background-color: #2a3042 !important">
            <th scope="col">#</th>

            <th scope="col">{{ $t("popups.customer_id") }}</th>
            <th scope="col">{{ $t("customers.name") }}</th>
            <th scope="col">{{ $t("customers.neighborhood") }}</th>
            <th scope="col">{{ $t("neighborhoods.area_code") }}</th>

            <th scope="col">{{ $t("customers.meter_no") }}</th>
            <th scope="col">{{ $t("customers.tariff") }}</th>
            <th scope="col">{{ $t("bills_receivable.remain") }}</th>
            <th scope="col">{{ $t("report.month") }}</th>
            <th scope="col">{{ $t("customers.created") }}</th>
            <th scope="col">{{ $t("customers.status") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(app, index) in billing_invoices" :key="app" class="">
            <td>{{ (page - 1) * limit + index + 1 }}</td>
            <td>{{ app?.id }}</td>
            <td>{{ app?.customer_name }}</td>
            <td>
              {{ $i18n.locale == "ar" ? app?.name : app?.name_en }}
            </td>
            <td>{{ app?.area_code || "-" }}</td>

            <td>{{ app.meter_no }}</td>
            <td>{{ parseFloat(app?.total_balance)?.toLocaleString() }}</td>
            <td>
              {{
                parseFloat(
                  app?.total_balance - app?.paid_balance
                )?.toLocaleString()
              }}
            </td>
            <td>{{ moment(app?.created).format("MMMM Y") }}</td>
            <td>{{ app?.updated?.split("T")[0] }}</td>
            <td>
              <h6
                v-if="
                  parseFloat(app?.paid_balance) !==
                  parseFloat(app?.total_balance)
                "
                class="text-danger"
              >
                {{ $t("popups.unPaid") }}
              </h6>
              <span
                v-if="
                  parseFloat(app?.paid_balance) ===
                  parseFloat(app?.total_balance)
                "
                class="text-success"
                >{{ $t("popups.paid") }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- end  table -->
    <div>
      <ul
        class="pagination pagination-rounded justify-content-center mb-2"
        style="cursor: pointer"
      >
        <li class="page-item" :class="{ disabled: page === 1 }">
          <a
            class="page-link"
            href="javascript:void(0);"
            @click="goToPage(page - 1)"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>

        <li
          class="page-item"
          :class="{ active: page === 1 }"
          v-if="pages[0] > 1"
        >
          <a class="page-link" @click="goToPage(1)">1</a>
        </li>
        <li class="page-item disabled" v-if="pages[0] > 2">
          <span class="page-link">…</span>
        </li>

        <li
          v-for="p in pages"
          :key="p"
          class="page-item"
          :class="{ active: p === page }"
        >
          <a class="page-link" @click="goToPage(p)">{{ p }}</a>
        </li>

        <li
          class="page-item disabled"
          v-if="pages.slice(-1)[0] < tot_pages - 1"
        >
          <span class="page-link">…</span>
        </li>
        <li
          class="page-item"
          :class="{ active: page === tot_pages }"
          v-if="pages.slice(-1)[0] < tot_pages"
        >
          <a class="page-link" @click="goToPage(tot_pages)">{{ tot_pages }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page === tot_pages }">
          <a
            class="page-link"
            href="javascript:void(0);"
            @click="goToPage(page + 1)"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
    <!--   Apps  Pagination     -->
    <!-- <div>
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="this.search ? searchAccounts(page - 1) : get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="this.search ? searchAccounts(p) : get(p)"
            >{{ p }}</a
          >
        </li>

        <li class="page-item" :class="{ disabled: page == tot_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="this.search ? searchAccounts(page + 1) : get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div> -->
    <!--end-->

    <div class="page-content container">
      <!-- <div class="page-header text-blue-d2">
                            <h1 class="page-title text-secondary-d1">
                                Invoice
                                <small class="page-info">
                                    <i class="fa fa-angle-double-right text-80"></i>
                                    ID: #111-222
                                </small>
                            </h1>

                            <div class="page-tools">
                                <div class="action-buttons">
                                    <a class="btn bg-white btn-light mx-1px text-95" href="#" data-title="Print">
                                        <i class="mr-1 fa fa-print text-primary-m1 text-120 w-2"></i>
                                        Print
                                    </a>
                                    <a class="btn bg-white btn-light mx-1px text-95" href="#" data-title="PDF">
                                        <i class="mr-1 fa fa-file-pdf-o text-danger-m1 text-120 w-2"></i>
                                        Export
                                    </a>
                                </div>
                            </div>
                        </div> -->
    </div>
  </Layout>
</template>

<style scoped>
body {
  margin-top: 20px;
  color: #484b51;
}

.text-secondary-d1 {
  color: #728299 !important;
}

.page-header {
  margin: 0 0 1rem;
  padding-bottom: 1rem;
  padding-top: 0.5rem;
  border-bottom: 1px dotted #e2e2e2;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: center;
  align-items: center;
}

.page-title {
  padding: 0;
  margin: 0;
  font-size: 1.75rem;
  font-weight: 300;
}

.brc-default-l1 {
  border-color: #dce9f0 !important;
}

#bill {
  width: 100%;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.text-grey-m2 {
  color: #888a8d !important;
}

.text-success-m2 {
  color: #86bd68 !important;
}

.font-bolder,
.text-600 {
  font-weight: 600 !important;
}

.text-110 {
  font-size: 110% !important;
}

.text-blue {
  color: #478fcc !important;
}

.pb-25,
.py-25 {
  padding-bottom: 0.75rem !important;
}

.pt-25,
.py-25 {
  padding-top: 0.75rem !important;
}

.bgc-default-tp1 {
  background-color: rgba(121, 169, 197, 0.92) !important;
}

.bgc-default-l4,
.bgc-h-default-l4:hover {
  background-color: #f3f8fa !important;
}

.page-header .page-tools {
  -ms-flex-item-align: end;
  align-self: flex-end;
}

.btn-light {
  color: #757984;
  background-color: #f5f6f9;
  border-color: #dddfe4;
}

.w-2 {
  width: 1rem;
}

.text-120 {
  font-size: 120% !important;
}

.text-primary-m1 {
  color: #4087d4 !important;
}

.text-danger-m1 {
  color: #dd4949 !important;
}

.text-blue-m2 {
  color: #68a3d5 !important;
}

.text-150 {
  font-size: 150% !important;
}

.text-60 {
  font-size: 60% !important;
}

.text-grey-m1 {
  color: #7b7d81 !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.modal-content {
  width: 800px;
}

.c {
  position: relative;
  right: 900px;
  top: 5px;
}

.tot {
  display: flex;
  justify-content: flex-end;
}

.tot2 {
  display: flex;
  justify-content: flex-end;
  right: 10px;
}
</style>
